import * as faIcons from './mapping';

export default faIcons;
export * from './mapping';
